





























































































































import { Component, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { mapGetters } from "vuex";
import store from "@/store";
import { CoeusAPI } from "../iop/coeus-api";
import { InputText } from "../components/search/input";
import { ICoeusDomainChildren, ICoeusDomainData, ICoeusDomainMeta } from "../iop/interfaces";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: { InputText },
  computed: {
    ...mapGetters("ui", ["nightMode"]),
  },
})
export default class MorpheusBrowserPage extends Vue {
  private domain = '';
  private error = false;
  private domainNotFound = false;
  private domainData: ICoeusDomainData = null;
  private domainMeta: ICoeusDomainMeta = null;
  private domainChildren: ICoeusDomainChildren = null;

  private get currentHeight(): number {
    return store.getters["network/height"];
  }

  private get isExpired(): boolean {
    return this.domainMeta.expiresAtHeight < this.currentHeight;
  }

  public async beforeRouteEnter(to: Route, from: Route, next: (vm: any) => void) {
    try {
      next((vm) => {
        
        if(to.params.domain) {
          vm.domain = to.params.domain;
          vm.search();
        }
      });
    }
    catch(e) {
      console.log(e);
    }
  }

  private onSearchClick(): void {
    const path = `/dns-browser/${this.domain}`;
    if(this.domain) {
      if(this.$route.path !== path) {
        this.$router.push(path);
      }
      else {
        this.search();
      }
    }
  }

  private onDirectLinkClick(): void {
    const url = `${CoeusAPI.getBaseUrl()}/resolve/${this.domain}`;
    window.open(url,'_blank');
  }

  private onDomainChange(event: any): void {
    const { value } = event.target;
    this.domain = value;
  }

  private async search(): Promise<void> {
    try {
      this.error = false;
      this.domainNotFound = false;
      const x =await CoeusAPI.getDomainData(this.domain);
      const results = await Promise.all([
        CoeusAPI.getDomainData(this.domain),
        CoeusAPI.getDomainMeta(this.domain),
        CoeusAPI.getDomainChildren(this.domain),
      ]);
      if(!results[0]) {
        this.domainNotFound = true;
        return;
      }
      this.domainData = results[0];
      this.domainMeta = results[1];
      this.domainChildren = results[2];
    } catch(e) {
      this.error = true;
    }
  }
}
